<template>
  <h6 class="mb-1">{{ order }}) {{ freeField1 }}</h6>
  <p>{{ freeField2 }}</p>
  <div class="d-flex flex-wrap">
    <button
      v-for="scale in scales"
      :key="scale"
      type="button"
      class="btn btn-nps"
      :class="[getColorClass(scale), { selected: value === scale }]"
      :title="scale"
      @click="setValue(scale)"
    >
      {{ scale }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'ZeroToTenScale',

  props: {
    order: {
      type: [String, Number],
      default: '1',
    },
    freeField1: {
      type: String,
      default: 'Selecione uma nota de 0 a 10',
    },
    freeField2: {
      type: String,
      default: '',
    },
    freeField3: {
      type: String,
      default: '',
    },
    userDistribution: {
      type: Object,
      default: null,
    },
    emailValue: {
      type: String,
      default: null,
    },
  },

  emits: ['setValue'],

  data() {
    return {
      scales: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      value: '',
    }
  },

  methods: {
    getColorClass(number) {
      if (number <= 6) return 'bg-nps-red'
      if (number <= 8) return 'bg-nps-yellow'
      return 'bg-nps-green'
    },

    setValue(value) {
      if (this.userDistribution) {
        const newUserDistribution = { ...this.userDistribution }
        newUserDistribution.value = value
        this.$emit('setValue', newUserDistribution)
      }
      this.value = value
    },
  },
  mounted() {
    if (this.userDistribution) {
      this.value =
        this.userDistribution.value === null
          ? ''
          : Number(this.userDistribution.value)
    }

    if (this.emailValue && this.userDistribution.value === null) {
      this.value = Number(this.emailValue)
      this.setValue(this.value)
    }
  },
}
</script>

<style scoped>
.btn-nps {
  display: inline-block;
  cursor: pointer;
  min-width: 50px;
  text-align: center;
  color: #fff;
  font-size: 1.2rem;
  padding: 0.5rem 1rem;
  margin: 0 0.5rem;
  border-radius: 4px;
  transition: background-color 0.3s ease, border 0.3s ease, box-shadow 0.3s ease;
  opacity: 0.5;
}

.bg-nps-red {
  background-color: #ff7f7e;
}

.bg-nps-red:hover {
  background-color: #e55c5c;
  border: 1px solid #d04545;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  opacity: 0.8;
}

.bg-nps-red.selected {
  background-color: #d04a4a;
  border: 1px solid #a62c2c;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  opacity: 1;
}

.bg-nps-yellow {
  background-color: #f9b73e;
}

.bg-nps-yellow:hover {
  background-color: #f29c1f;
  border: 1px solid #d98b1d;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  opacity: 0.8;
}

.bg-nps-yellow.selected {
  background-color: #f2a423;
  border: 1px solid #c98a1d;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  opacity: 1;
}

.bg-nps-green {
  background-color: #22aa58;
}

.bg-nps-green:hover {
  background-color: #1a8e4d;
  border: 1px solid #1a7d44;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  opacity: 0.8;
}

.bg-nps-green.selected {
  background-color: #1b8e4a;
  border: 1px solid #167340;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  opacity: 1;
}

@media (max-width: 912px) {
  .btn-nps {
    margin-bottom: 0.5rem;
  }
}
</style>
